import { threadId } from "worker_threads";

export class AssetsManagementModel {
    constructor() {
        this.penDriveBlocked = false;
        this.recoveryDiskPrepared = false;
        this.adminGuestUserPrepared = false;
        this.belarcInstalled = false;
        this.remoteAccessSoftwareInstalled = false;
        this.cyberoamInstalled = false;
        this.printerAccessInstalled = false;
        this.pgbTagAffixed = false;
        this.serialServiceTagAffixed = false;
        this.personalAsset = undefined;
    }
    accountNo: string;
    adminGuestUserPrepared: Boolean;
    assetName: string;
    subType: SubTypeModel;
    assetType: {
        id: number,
        name: string,
        subType: SubTypeModel[];
    }
    belarcInstalled: Boolean;
    comment: string;
    cyberoamInstalled: Boolean;
    dateOfPurchase: any;
    dateOfRetirementOfAsset: any;
    dateOfSale: any;
    expiryDate: any;
    id: number;
    make: string;
    modelNo: string;
    pgbTagAffixed: Boolean;
    printerAccessInstalled: Boolean;
    productKey: number;
    recoveryDiskPrepared: Boolean;
    remoteAccessSoftwareInstalled: Boolean;
    serialServiceTagAffixed: Boolean;
    serviceProvider: string;
    serviceTagNumber: string;
    serviceTagNumberUrl: string;
    simNo: number;
    systemConfigUrl: string;
    release: Boolean;
    retired: Boolean;
    block: Boolean;
    personalAsset: Boolean;
    penDriveBlocked: Boolean;
    branch: BranchModel;
    requsetDate: any;
    ipAddress: string;
    userId: string;
    password: string;
    vendorInvoiceNo: string;
    vendorInvoiceDate: any;
    vendorInvoicePhotoUrl: any;
    pgbPurchaseAccountingVoucherNo: string;
    pgbPurchaseAccountingVoucherDate: any;
    pgbPurchaseVoucherPhotoUrl: any;
    belarcUrl: any;
}
export class BranchModel {
    id: number;
    name: string;
}

export class SubTypeModel {
    id: number;
    name: string;
}

export class MainAssetModel {
    constructor() {
        this.asset = null;
        this.fromUser = null;
        this.toUser = null;
        this.id = null;
        this.requsetDate = null;
        this.status = "";
        this.transferedDate = null;
    }
    asset: AssetsManagementModel;
    // transferServiceTagNumber: TransferServiceTagNumberModel;
    fromUser: TransferUserModel;
    toUser: TransferUserModel;
    id: number;
    release: boolean;
    requsetDate: any;
    status: string;
    transferedDate: any;
}

// export class TransferServiceTagNumberModel {
//     id: number;
//     serviceTagNumber: string;
//     user: TransferUserModel;
// }

export class TransferUserModel {
    id: number;
    firstName: string;
    lastName: string;
    middleName: string;
}